import StepLineIcon from "@svg/landing/line";
import StepShapeIcon from "@svg/landing/step";
import StepTabletLineIcon from "@svg/landing/tablet-line";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FESTIVAL_TYPE, StepData } from "@features/landing/types";
import {
  festivalStepLabel,
  festivalStepsColors,
} from "@features/landing/helpers/constants/constants";

interface Props {
  data: StepData[];
  discount: string | null;
  festivalType: FESTIVAL_TYPE;
}

const StepsLanding: React.FC<Props> = ({ data, festivalType }) => {
  const formatNumber = (value: number | string, isMoney = false) => {
    const formatted = toFarsiNumber(value);
    return isMoney ? separateMoneyNumbers(formatted) : formatted;
  };

  const getRangeText = (from: number, to: number) => {
    return from === 0 ? "تا" : "بیشتر از";
  };

  const label = festivalStepLabel[festivalType];

  return (
    <div className="relative flex w-full h-[776px] xl:h-[136px] justify-center overflow-hidden my-8 lg:items-center">
      <StepLineIcon className="absolute top-0 xl:top-auto z-0 block rotate-90 lg:rotate-0 md:hidden xl:block" />
      <StepTabletLineIcon className="absolute top-20 z-0 hidden md:block xl:hidden" />

      <div className="absolute z-10 flex w-[153px] md:w-[374px] xl:w-full flex-col xl:flex-row xl:flex-wrap items-center justify-center gap-6">
        {data.map((step, index) => {
          const isEven = index % 2 === 0;

          const rangeText = getRangeText(step.from, step.to);
          const toValue = formatNumber(step.to, true);

          const discountValue = step.is_percent
            ? formatNumber(step.discount)
            : formatNumber(step.discount, true);

          return (
            <div
              key={index}
              className={classNames(
                "relative flex items-center justify-center",
                isEven ? "self-start" : "self-end"
              )}
            >
              <div className="absolute z-10 flex flex-col items-center justify-center text-[#0C365C]">
                <p className="text-sm font-medium">
                  {rangeText}{" "}
                  <span className="text-lg font-bold">{toValue}</span> {label}
                </p>

                <p className="text-sm font-medium">
                  <span className="text-lg font-bold">{discountValue}</span>{" "}
                  {label}
                </p>

                <p className="text-sm font-medium">تخفیف</p>
              </div>
              <StepShapeIcon fill={festivalStepsColors[index]} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepsLanding;
